<template>
  <v-app>
    <v-toolbar
      id="headerAgent"
      fixed
      app
      clipped
      height="48"
      :class="{ 'mobile-toolbar': isMobile }"
      :style="{ 'padding-left': getLeftPadding }"
    >
      <header-toolbar
        :is-mini-sidebar="isMiniSidebar"
        @show-invite-buyer-modal="inviteBuyerModal = true"
      />
    </v-toolbar>
    <!------------------->
    <!-- Agent Sidebar -->
    <!------------------->
    <v-navigation-drawer
      id="agentSidebar"
      v-model="vdrawer"
      :mini-variant="
        getWindowWidth >= 1264 ? isMiniSidebar : miniSidebarValue()
      "
      app
    >
      <!-- Title -->
      <header-menu
        :is-mini-sidebar="isMiniSidebar"
        :menu-items="adjustedMenuItems"
        @image-clicked="imageClicked"
      />
      <v-dialog
        v-if="!isMobile"
        v-model="inviteBuyerModal"
        persistent
        :width="modal.width"
        :max-width="modal.maxWidth"
      >
        <template v-slot:activator="{ on }">
          <v-list-tile
            v-show="isMobile"
            id="menuItemInviteBuyer"
            :class="{
              'sidebar-active-link': inviteBuyerModal,
              'sidebar-mini-link': isMiniSidebar,
              'sidebar-link': !isMiniSidebar
            }"
            ripple
            v-on="on"
          >
            <v-list-tile-content>
              <v-list-tile-title>INVITE BUYER</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-dialog>
    </v-navigation-drawer>
    <!------------------->
    <!------------------->
    <!-- Agent Content. -->
    <v-content
      :style="{
        'padding-left': getLeftPadding,
        'background-color':
          getCurrentRoute == 'agent-invite-client' && isMobile
            ? 'white'
            : '#f7f7f7'
      }"
    >
      <page-content />
    </v-content>
    <v-dialog
      v-model="inviteBuyerModal"
      persistent
      :width="modal.width"
      :max-width="modal.maxWidth"
    >
      <invite-buyer-form @on-modal-close="closeInviteBuyerModal($event)" />
    </v-dialog>
    <v-snackbar v-model="showInviteBuyerSnackbar" :timeout="4000" :top="true">
      {{ inviteBuyerSnackbarMessage }}
      <v-btn flat color="red" @click.stop="closeSnackbar()">
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import HeaderToolbar from './HeaderToolbar'
import HeaderMenu from '../common/navigation/HeaderMenu'
import PageContent from './PageContent'
import refreshContent from '../mixins/refreshContent'
import InviteBuyerForm from './invite/InviteBuyerForm.vue'
import colors from '../../scss/_colors.scss'
import { isEmpty } from '../../utils/generalUtils'

export default {
  components: {
    InviteBuyerForm,
    HeaderToolbar,
    HeaderMenu,
    PageContent
  },

  mixins: [refreshContent],

  data() {
    return {
      isMiniSidebar: false,
      vdrawer: null,
      inviteBuyerModal: false,
      showInviteBuyerSnackbar: false,
      inviteBuyerSnackbarMessage: null,
      shortMenuItems: [
        { icon: 'search', text: 'SEARCH', link: 'agent-search' },
        { icon: 'calendar_today', text: 'CALENDAR', link: 'calendar' },
        { icon: 'feedback', text: 'FEEDBACK', link: 'feedback' },
        { icon: 'message', text: 'COMMUNICATION', link: 'communication' },
        { icon: 'person', text: 'ACCOUNT', link: 'agent-account' },
        { icon: '', text: 'INVITE BUYER', link: 'agent-invite-client' }
      ],
      fullMenuItems: [
        {
          icon: 'home',
          text: 'TASK MANAGER',
          link: 'home',
          children: [
            { text: 'TASK VIEW', link: 'Task-Manager / Task-View' },
            { text: 'CLIENT VIEW', link: 'client-view' }
          ]
        },
        { icon: 'search', text: 'SEARCH', link: 'agent-search' },
        {
          icon: 'access_time',
          text: 'PLANNER',
          link: 'planner'
        },
        { icon: 'calendar_today', text: 'CALENDAR', link: 'calendar' },
        {
          icon: 'person_pin',
          text: 'CLIENT DETAIL',
          link: 'client-detail'
        },
        { icon: 'feedback', text: 'FEEDBACK', link: 'feedback' },
        { icon: 'message', text: 'COMMUNICATION', link: 'communication' }
      ],
      colors
    }
  },

  computed: {
    /**
     * Mapping the selected client getter to check if isn't null
     */
    ...mapState('client', ['clientData']),
    ...mapState('home', ['activeRoute']),
    ...mapState('style', ['modal']),
    ...mapState('common', ['drawer', 'isMobile', 'dialogData']),

    getWindowWidth() {
      const windowWidth = this.$store.state.home.windowWidth
      return windowWidth
    },

    getLeftPadding() {
      if (this.$store.state.home.windowWidth >= 1264) {
        if (this.isMiniSidebar) return '80px'
        else return '210px'
      } else {
        return '0px'
      }
    },

    getCurrentRoute() {
      return this.activeRoute
    },

    pathInArrayForm() {
      if (this.$route.name === undefined) {
        return []
      }
      return this.$route.path
        .split('/')
        .map(val => ({ text: val.replace('-', ' ') }))
    },

    adjustedMenuItems() {
      if (this.isMobile) {
        return this.shortMenuItems
      } else {
        return this.fullMenuItems
      }
    }
  },

  watch: {
    activeRoute(newValue, oldValue) {
      if (newValue && newValue.name === 'agent-search' && !this.isMiniSidebar) {
        this.isMiniSidebar = true
      }
    },

    drawer() {
      if (this.vdrawer !== this.drawer) {
        this.vdrawer = this.drawer
      }
    },

    vdrawer() {
      if (this.vdrawer !== this.drawer) {
        this.setDrawerState(this.vdrawer)
      }
    }
  },

  created() {
    if (isEmpty(this.agentData)) this.getAgentData()
    this.setProfileStatus('agent')
  },

  methods: {
    ...mapActions('common', ['profileLogout']),
    ...mapMutations('common', {
      setProfileStatus: 'SET_PROFILE_STATUS',
      setDrawerState: 'SET_DRAWER_STATE'
    }),

    toggleDrawer() {
      this.setDrawerState(!this.drawer)
    },

    imageClicked() {
      if (this.getWindowWidth >= 1264) {
        this.isMiniSidebar = !this.isMiniSidebar
        return
      }
      return this.toggleDrawer()
    },

    miniSidebarValue() {
      this.isMiniSidebar = false
      return false
    },

    closeInviteBuyerModal(data) {
      const { showMessage, message } = data
      if (showMessage) {
        this.showInviteBuyerSnackbar = true
        this.inviteBuyerSnackbarMessage = message
      }
      this.inviteBuyerModal = false
    },

    closeSnackbar() {
      this.showInviteBuyerSnackbar = false
      this.inviteBuyerSnackbarMessage = null
    }
  }
}
</script>

<style lang="sass">
#agentSidebar
  z-index: 11 !important
  .primary--text
    color: $hwayzBlack !important
    caret-color: $hwayzBlack !important
</style>

<style lang="sass" scoped>
// @Toolbar style
.mobile-layout-content
  background: white
  height: 100%

// @Sidebar content
#agentSidebar
  font-weight: 300
  background-color: $hwayzWhite !important
  box-shadow: 3px 1px 5px rgba(0, 0, 0, 0.2)
  max-width: 210px !important
.v-list
  padding-bottom: 0 !important

.navigation-toggle--menu
  .v-btn__content
    i
      color: $hwayzWhite !important

.sidebar-link .v-list__tile__action, .v-list__tile__avatar
  min-width: 40px !important
#sidebar .v-list__tile__title
    font-size: 12px
    font-family: Roboto,sans-serif
@media only screen and (max-width: 600px)
    margin-top: 2rem !important
    .v-list__tile__content, .v-list__tile__title
      font-size: 12px
      font-family: Roboto,sans-serif
    .sidebar-submenu__link div, .v-list__tile div, #sidebar .v-list__tile__title
      font-size: 12px !important
      font-family: Roboto,sans-serif
.sidebar-submenu__link div
  width: 100%

.opacity-zero
  opacity: 0

.opacity-one
  opacity: 1
  transition: opacity 0.5s ease

// @Content style

.client-name
  background: transparent
  color: $hwayzBlack
  padding-top: 16px !important

.hwayzSun
  background-color: $hwayzSun !important
.hwayzTeal
  background-color: $hwayzTeal !important

.layout-content
  @media only screen and (min-width: 600px)
    padding: 0
  @media only screen and (min-width: 960px)
    padding: 2rem 1rem !important
</style>
